module.exports = __webpack_public_path__ + "img/concreted_paved.1fd9a6e2.png";